import type { TableSettingsState } from '@/helpers/cookieStorage/userSettings/tableSettings/shared'

export const PAGE_SIZE = 10

/**
 * Loading rows: the market count of the median V1 vault pageview (PostHog, 30 days to
 * 2026-10-09). Fewer rows than loaded moves content below; matching the median keeps
 * the average move smallest.
 */
export const MARKET_ALLOCATION_SKELETON_ROWS = 6

export const MARKET_ALLOCATION_DEFAULT_TABLE_SETTINGS: TableSettingsState = {
  columnVisibility: {},
  sorting: [
    {
      id: 'supplyAssetsUsd',
      desc: true
    }
  ],
  columnFilters: [],
  columnOrder: [],
  version: 2
}
export const MARKET_ALLOCATION_STORAGE_KEY = 'marketAllocationTable'
